import { getApiUrl } from '../config/api';

const ROLES_WITH_MUSIC_STYLE_GATE = ['Student', 'Teacher', 'Admin'];

export function hasPreferredMusicStyles(
  infos: Record<string, unknown> | null | undefined,
): boolean {
  const styles = infos?.preferredMusicStyles;
  return Array.isArray(styles) && styles.length > 0;
}

export function shouldPromptForMusicStyles(role: string): boolean {
  return ROLES_WITH_MUSIC_STYLE_GATE.includes(role);
}

export async function getMusicStyleSelectionGate(
  userId: string,
  role: string,
): Promise<string | null> {
  if (!userId || !shouldPromptForMusicStyles(role)) return null;

  const response = await fetch(getApiUrl(`/api/v1/user/${userId}`), {
    credentials: 'include',
    cache: 'no-store',
  });
  const data = await response.json().catch(() => ({}));

  return hasPreferredMusicStyles(data?.user?.userInfos) ? null : userId;
}

export async function savePreferredMusicStyles(
  userId: string,
  styles: string[],
): Promise<void> {
  const response = await fetch(getApiUrl(`/api/v1/user/${userId}`), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ preferredMusicStyles: styles }),
  });
  const data = await response.json().catch(() => ({}));

  if (!response.ok || !data?.success) {
    const validationMessage = Array.isArray(data?.errors)
      ? data.errors.map((error: any) => error.msg || error.message).filter(Boolean).join(', ')
      : '';
    throw new Error(validationMessage || data?.message || 'Unable to save music styles');
  }
}
